import React, {Component} from 'react';
import {gpn} from "../GPN"
import Icon from "./MUI/Icon";
import config from "../config";

class SideBar extends Component {

    state = {
        items: [
            {t: "داشبورد", i: "tachometer-average", p: "/", a: "dashboard"},
            {t: "کاربران", i: "user", p: "/users", a: "users"},
            {t: "سفارشات", i: "sort-shapes-up", p: "/orders", a: "orders"},
            {t: "پرداخت ها", i: "money-check-edit", p: "/payments", a: "payments"},
            {t: "خدمات", i: "concierge-bell", p: "/services", a: "services"},
            {t: "خدمات انتخابی (کاربر)", i: "concierge-bell", p: "/services2", a: "services"},
            {t: "طرح های تسهیلات", i: "file-plus", p: "/facilities", a: "facilities"},
            {t: "ارسال پیامک", i: "book", p: "/sms", a: "sms"},
            {t: "فضای ابری", i: "download", p: "/storage", a: "storage"},
            {t: "درگاه پرداخت", i: "money-check", p: "/gateway", a: "gateway"},
            {t: "مدیران", i: "users", p: "/admins", a: "admins"},
            {t: "تنظیمات", i: "tools", p: "/settings", a: "settings"},
            {t: "لاگ ها", i: "file-pdf", p: "/logs", a: "settings"},
            {t: "بلک لیست", i: "close", p: "/black-list", a: "blacklist"},
            {t: "استعلام", i: "refresh", p: "/estelam", a: "estelam"}
        ]
    };

    render() {
        const {permissions} = this.props;
        const {items} = this.state;
        return (
            <div className="col-md-auto">
                <aside className="sidebar">
                    {
                        items.map((it, i) =>
                            config.hasAccess(permissions, it.a) ?
                                <div className="side-item"
                                     key={"side" + i}
                                     onClick={() => this.props.navigate(it.p)}>
                                    <div className="row">
                                        <div className="col-auto">
                                            <Icon i={it.i}/>
                                        </div>
                                        <div className="col">{it.t}</div>
                                    </div>
                                </div>
                                : null
                        )
                    }
                </aside>
            </div>
        );
    }
}

export default gpn(SideBar);